import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  Switch,
  CircularProgress,
} from "@mui/material";
import { Formik, Form } from "formik";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddIcon from "@mui/icons-material/Add";
import AddSlotModal from "./addSlotModal";
import { useGetAllBeauticianSlotsQuery } from "slices/beautyApp/beauticianSlice";
import { useNavigate } from "react-router-dom";

const daysOfWeek = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const variables = [
  {
    id: "testing",
    name: "test",
  },
];

function Step5({ val, onNext }) {
  const naviagte = useNavigate();
  const [slotModalOpen, setSlotModalOpen] = useState(false);
  const [selectedDayIndex, setSelectedDayIndex] = useState(null);
  const [editingSlotData, setEditingSlotData] = useState(null);

  const {
    data: initialData,
    isSuccess,
    isFetching,
    refetch,
  } = useGetAllBeauticianSlotsQuery(val?._id);

  const [initialValues, setInitialValues] = useState({ weekSlots: [] });

  useEffect(() => {
    if (isSuccess && Array.isArray(initialData?.data)) {
      const updatedWeekSlots = daysOfWeek.map((day) => {
        const matchedDay = initialData.data.find((d) => d.day === day);
        return {
          day,
          active: !!matchedDay,
          slots: matchedDay ? matchedDay.slots : [],
          _id: matchedDay?._id || null, // ✅ Include _id
        };
      });
      setInitialValues({ weekSlots: updatedWeekSlots });
    }
  }, [isSuccess, initialData]);

  if (isFetching) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values) => {
        const hasAtLeastOneSlotWithId = values.weekSlots.some(
          (day) => day._id && day.slots.length > 0
        );

        if (!hasAtLeastOneSlotWithId) {
          alert("Please add at least one slot.");
          return;
        }

        naviagte("/beauty-app/beauticians");
      }}
    >
      {({ values, setFieldValue }) => {
        const activeDays = values.weekSlots.filter((day) => day.active);

        return (
          <Form>
            <Box>
              {activeDays.length < 8 && (
                <>
                  {activeDays.map((dayObj, index) => (
                    <Box
                      key={dayObj.day}
                      sx={{
                        mb: 3,
                        p: 2,
                        border: "1px solid #ccc",
                        borderRadius: 2,
                      }}
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography variant="h6">
                          {dayObj.day.toUpperCase()}
                        </Typography>
                        <Box display="flex" alignItems="center">
                          <Typography variant="body2">Active</Typography>
                          {/* <Switch
                            checked={dayObj.active}
                            onChange={() =>
                              setFieldValue(
                                `weekSlots[${index}].active`,
                                !dayObj.active
                              )
                            }
                          /> */}
                        </Box>
                      </Box>

                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={() => {
                          setSelectedDayIndex(index);
                          setEditingSlotData({
                            _id: dayObj._id,
                            active: dayObj.active,
                            day: dayObj.day,
                            slots: dayObj.slots,
                          });
                          setSlotModalOpen(true);
                        }}
                        sx={{ mt: 2 }}
                      >
                        {dayObj.slots.length > 0 ? "Update Slots" : "Add Slots"}
                      </Button>
                    </Box>
                  ))}

                  {/* Add New Day Box */}
                  <Box
                    sx={{
                      border: "1px dashed #90caf9",
                      borderRadius: 3,
                      p: 4,
                      textAlign: "center",
                      background: "linear-gradient(to right, #e3f2fd, #f1f8ff)",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.05)",
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        boxShadow: "0px 6px 16px rgba(0,0,0,0.1)",
                      },
                    }}
                  >
                    <CalendarMonthIcon
                      sx={{
                        fontSize: 48,
                        color: "#1976d2",
                        mb: 1,
                      }}
                    />
                    <Typography
                      variant="h6"
                      sx={{ color: "#1976d2", fontWeight: 600 }}
                      gutterBottom
                    >
                      Add New Day Slot
                    </Typography>

                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        setSlotModalOpen(true);
                      }}
                      sx={{
                        textTransform: "none",
                        px: 4,
                        py: 1.5,
                        fontWeight: 500,
                        borderRadius: 2,
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "#1565c0",
                        },
                      }}
                    >
                      Add Slot
                    </Button>
                  </Box>
                </>
              )}
            </Box>

            <Divider sx={{ my: 4 }} />

            <Button type="submit" variant="contained" color="primary">
              Save
            </Button>

            <AddSlotModal
              val={val}
              open={slotModalOpen}
              onClose={() => {
                setSlotModalOpen(false);
                setEditingSlotData(null);
              }}
              initialData={editingSlotData} // ✅ Pass full slot data here
              onSave={() => {
                refetch(); // ✅ Re-fetch slot data from backend
                setSlotModalOpen(false);
                setEditingSlotData(null);
              }}
            />
          </Form>
        );
      }}
    </Formik>
  );
}

export default Step5;
